// Generated by CoffeeScript 1.12.7
(function() {
  exports.createLink = function(element, link) {
    var base;
    if (element.meta == null) {
      element.meta = {};
    }
    if ((base = element.meta).links == null) {
      base.links = [];
    }
    return element.meta.links.push(link);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/eidolon/lib/util.js
// module id = 129
// module chunks = 0